<template>
  <div class="flex items-center">
    <feather-icon v-if="done" :class="actionElementCss" icon="CheckCircleIcon" class="w-5 cursor-pointer" @click.stop="$emit('toggleDone', !done)" />

    <!-- <span v-else> -->
    <vx-tooltip v-else class="items-center flex flex-wrap" text="mark as 'done today'" delay="0.5s" >
      <feather-icon :class="actionElementCss" icon="CircleIcon" class="w-5 cursor-pointer" @click.stop="$emit('toggleDone', !done)" />
    </vx-tooltip>
    <!-- </span> -->

  </div>
</template>


<script>
import GoalList from '../Goals/List'
import TaskList from '../Tasks/TaskList'
import RoutineList from '../Routines/RoutineList'
export default {
  components: {
    RoutineList,
    TaskList,
    GoalList
  },
  props: ['done'],
  data () {
    return {

    }
  },
}
</script>
